import { useStore } from 'vuex'
import {
  AgriculturalLoanContractListRouteName,
  AgriculturalLoanContractDetailRouteName,
  AgriculturalLoanApplyFormRouteName,
  AgriculturalLoanAddressSelectRouteName,
  AgriculturalLoanPackageSelectionRouteName,
  AgriculturalLoanDeviceListRouteName,
} from '@/defination/constant'
import { ProductSelectionItem, ProductSelectionDetailResponse } from '@/types/agricultura-loan'
import { getProductSelectionList, getProductSelectionDetail } from '@/apis/agricultura-loan'

export function useArgiculturaLoanKeepAliveControll() {
  const $store = useStore()
  const addKeepAliveWrap = (routeName: string) => () => {
    $store.commit('addKeepAliveItem', { routeName })
  }
  const removeKeepAliveWrap = (routeName: string) => () => {
    $store.commit('removeKeepAliveItem', { routeName })
  }
  const addContractListKeepAlive = addKeepAliveWrap(AgriculturalLoanContractListRouteName)
  const removeContractListKeepAlive = removeKeepAliveWrap(AgriculturalLoanContractListRouteName)
  const addApplyFormKeepAlive = addKeepAliveWrap(AgriculturalLoanApplyFormRouteName)
  const removeApplyFormAlive = removeKeepAliveWrap(AgriculturalLoanApplyFormRouteName)

  return {
    addContractListKeepAlive,
    removeContractListKeepAlive,
    addApplyFormKeepAlive,
    removeApplyFormAlive,
  }
}

// 使用套餐选配信息
let cachePageageSelectListData: Array<ProductSelectionItem> = []
const cachePackageDetailData: Record<string, ProductSelectionDetailResponse> = {}
export function usePageSelectionInfo() {
  async function getPackageSelections() {
    if (cachePageageSelectListData?.length) {
      return cachePageageSelectListData
    }
    try {
      const data = await getProductSelectionList()
      cachePageageSelectListData = data.data
      return data.data
    } catch (error) {
      console.log('eror', error)
      return Promise.reject(error)
    }
  }

  async function getPackageDetail(guid: string) {
    if (cachePackageDetailData[guid]) {
      return cachePackageDetailData[guid]
    }
    try {
      const data = await getProductSelectionDetail(guid)
      cachePackageDetailData[guid] = data
      return data
    } catch (error) {
      console.log('error', error)
      return Promise.reject(error)
    }
  }

  return {
    getPackageSelections,
    getPackageDetail,
  }
}
